import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'awbFormatter',
  standalone: false,
})
export class AwbFormatter implements PipeTransform {
  // @param value: string
  // @param args: any

  transform(value: string, args?: any): string {
    if (!value) {
      return '-';
    }

    if (value.length <= 3) {
      return value;
    }

    return `${value.slice(0, 3)} - ${value.slice(3)}`;
  }
}
